'use client'
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Icon,
  Typography,
} from '@repo/ui/components'
import Image from 'next/image'
import React, { useState } from 'react'
import { useTranslate } from '../..'
import type { CSSVariableColor } from '@repo/ui/types'

interface InformationDialogSimpleProps {
  title: string
  children: React.ReactNode
  icon?: React.ReactNode
  iconColor?: CSSVariableColor
  mediaType?: 'image' | 'video' | 'text'
  mediaUrl?: string
  trigger: React.ReactNode
}

export const InformationDialogSimple = (
  props: InformationDialogSimpleProps,
) => {
  const { title, children, mediaType = 'text', mediaUrl, trigger } = props
  const [open, setOpen] = useState(false)
  const { t } = useTranslate()

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger className='flex'>{trigger}</DialogTrigger>
      <DialogContent className='w-full sm:max-w-[450px] !px-0'>
        <DialogHeader className='flex flex-col gap-2xs'>
          <DialogTitle className='text-center mb-md'>
            <Typography
              size='md'
              color='text-neutral-surface-100'
              weight='bold'
            >
              {title}
            </Typography>
          </DialogTitle>
        </DialogHeader>
        <div className='text-md text-neutral-surface-100 max-h-[50dvh] overflow-y-auto px-md'>
          {children}
        </div>
        <DialogFooter className='flex flex-col gap-md px-md'>
          <Button
            onClick={() => setOpen(false)}
            width='full'
            variant='ghost'
            color='neutral'
          >
            {t('common_back')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
